import { Dispatch } from "redux";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

export const viewClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.PRIMARY_CARE_PDF_MODAL,
      metaData: { rowData: {} },
    }),
  );
};
